import { Component } from '@opten/compiler/metadata/component';

import Swiper, { HashNavigation, Keyboard, Mousewheel, Autoplay } from 'swiper';


Swiper.use([Keyboard, Mousewheel, HashNavigation, Autoplay]);

@Component({ className: 'js-gallery-slider' })
export class GallerySliderComponent {
	public swiper: Swiper;
	
	constructor(private element: HTMLElement) {		
        const duration = this.element.dataset.duration;
		this.swiper = new Swiper(this.element, {
            autoplay: {
                delay: parseInt(duration)
            },			
            loop: true,
			speed: 1000,					
		});		
	}
}
